module.exports = function(login) {
	'use strict'
	login.directive('loginDir',loginDir);
	loginDir.$inject=['$state', '$timeout', '$http','postDataService','alertService', 'authtokenService', '$rootScope', 'refreshtokenService','navigationService','config','serverError','offlineError'];
	function loginDir($state,$timeout, $http,postDataService, alertService, authtokenService, $rootScope, refreshtokenService,navigationService,config,serverError, offlineError) {
		return {
			template: require('./partial/login.html'),
			controller: 'loginCtrl',
			controllerAs: 'vml',
			link: function(scope, element, attrs, ctrl) {
				$rootScope.navigation = false;
				scope.signIn = true;
				scope.submitted = false;
				var isAuth = false; 
				scope.submit = function($event) {
					if(scope.userForm.$valid) {	
							postDataService.save({param1:'auth', param2: 'login'},{'email':ctrl.userName,"password": ctrl.password}).$promise.then(function(dataAuth){
								var access_token = dataAuth.access_token;
								var avatar = dataAuth.user.avatar;
								var refresh_token = dataAuth.refresh_token;
								var name = dataAuth.user.name;
								var lastName = dataAuth.user.last_name
								var id = dataAuth.user.id;
								var role_id = dataAuth.user.role._id;
								var aitools = dataAuth.aitools;
								authtokenService.setToken(access_token);
								authtokenService.setrefreshToken(refresh_token);
								authtokenService.setNameandAvatarandIdandroleId(name, lastName, avatar, id, role_id, aitools);
								isAuth =true;
								$rootScope.$broadcast('is-aunthenticated', {isAuth:isAuth});
     							scope.signIn = true;
								alertService('success','Success ', dataAuth.message, 1000);
								// var promise = navigationService.getNavigation();
								if($rootScope.role_id == 'comments-moderator') {
	                				$state.go('app.allcomments');
	                			}else {
									$state.go('app.allposts');
	                			}	
						  
							}, function(error) {
								if(!window.navigator.onLine) {
									offlineError()
									return
								  }
								if(error.status==502) {
									serverError();
								}else {
									scope.signIn = false;
									alertService('danger','Opps! ',(error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
								}
							});			 	
					} else {
						$event.preventDefault();
						scope.submitted = true;
					}
				}
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/loginModule/js/directive/loginDirective.js
// module id = 503
// module chunks = 0